export default {
  buttons: { done: 'Fine' },
  title: 'Posizione',
};
